import type { ConfirmEmailChangeResponse } from '@shared/schemas/account';

import api from '@/shared/api/api-client';

import type { ConfirmedChange } from '../domain/confirm-email-change.model';
import type { ConfirmEmailChangeGateway } from './confirm-email-change.gateway';

/**
 * Real implementation over the shared api client; the single place that knows the
 * endpoint. The client prefixes `/v1`, and `/v1/auth/*` is CSRF-exempt and reachable
 * without a session (see `middleware/public-routes.ts`), which is what lets this run
 * for a visitor who is not signed in; and who, after it, cannot be.
 *
 * `api.post` already unwraps the `{ success, data }` envelope.
 */
export const httpConfirmEmailChangeGateway: ConfirmEmailChangeGateway = {
  confirm: async (token: string): Promise<ConfirmedChange> => {
    const data = await api.post<ConfirmEmailChangeResponse['data']>(
      '/auth/confirm-email-change',
      { token },
    );
    return { email: data.email, revokedSessions: data.revoked_sessions };
  },
};
